(function() {
    'use strict';

    angular.module('process')
        .controller('ProcessCreateController', ProcessCreateController);

    ProcessCreateController.$inject = ['$state', 'processDataSrvc', 'notificationSrvc', 'processMessagesConst', 'errorNotificationSrvc'];

    function ProcessCreateController($state, processDataSrvc, notificationSrvc, processMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            description_pl: [],
            description_en: [],
            description_de: [],
            description_cpde: [],
            description_cpen: [],
            nonFieldErrors: []
        };
        self.processData = {
            description_pl: null,
            description_en: null,
            description_de: null,
            description_cpde: null,
            description_cpen: null
        };

        self.createProcess = createProcess;
        self.cleanErrors = cleanErrors;

        function createProcess() {
            processDataSrvc.create(
                self.processData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", processMessagesConst.add);
                    $state.go('layout.process.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
